"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AETH_1 = require("./contracts/AETH");
var AETHF_1 = require("./contracts/AETHF");
var ANKR_1 = require("./contracts/ANKR");
var AnkrDeposit_1 = require("./contracts/AnkrDeposit");
var Config_1 = require("./contracts/Config");
var GlobalPool_1 = require("./contracts/GlobalPool");
var Governance_1 = require("./contracts/Governance");
var ContractFactory = /** @class */ (function () {
    function ContractFactory(web3, chainId) {
        this.AETH = new AETH_1.AETH(web3, chainId);
        this.AETHF = new AETHF_1.AETHF(web3, chainId);
        this.ANKR = new ANKR_1.ANKR(web3, chainId);
        this.AnkrDeposit = new AnkrDeposit_1.AnkrDeposit(web3, chainId);
        this.Config = new Config_1.Config(web3, chainId);
        this.GlobalPool = new GlobalPool_1.GlobalPool(web3, chainId);
        this.Governance = new Governance_1.Governance(web3, chainId);
    }
    return ContractFactory;
}());
exports.default = ContractFactory;
//# sourceMappingURL=ContractFactory.js.map